import { showGlobalDialogError } from "../components/error";
import { apiClient } from "./apiClient.services";

function getAuthData() {
	return {
		businessId: localStorage.getItem("businessId"),
	};
}

export const GetMarketplaceRegions = async (value) => {
	const { businessId } = getAuthData();

	try {
		return await apiClient(`/core/platforms/${value}/regions${localStorage.getItem("businessId") ? `?businessId=${businessId}`: ''}`);
	} catch (e) {
		throw e;
	}
}

export const GetMarketplace = async (businessIdseller, region) => {
	const { businessId } = getAuthData();
	try {
		return await apiClient(`/core/platforms/${businessIdseller}/marketplaces${localStorage.getItem("businessId") ? `?businessId=${businessId}`: ''}`);
	} catch (e) {
		showGlobalDialogError();
		throw e;
	}
}